import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];

        // If opened as a popup, send session_id back to the opener and close
        if (window.opener) {
          window.opener.postMessage({ type: 'google-auth-callback', sessionId }, window.location.origin);
          window.close();
          return;
        }
        
        // Fallback: handle directly if not a popup (e.g. popup was blocked)
        try {
          await handleGoogleCallback(sessionId);
          toast.success("Login successful!");
          navigate("/", { replace: true });
        } catch (error) {
          console.error("Google auth error:", error);
          toast.error("Google login failed. Please try again.");
          navigate("/login", { replace: true });
        }
      } else {
        navigate("/login", { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-primary" />
        <p className="text-muted-foreground">Completing login...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
